import { render } from "./SsoCallbackPage.vue?vue&type=template&id=20efe5b3"
import script from "./SsoCallbackPage.vue?vue&type=script&lang=js"
export * from "./SsoCallbackPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__